import { sharedActions } from './shared-actions';
import { appStateSlice } from './slice.app-state';

export const actions = {
  ...sharedActions,
  ...appStateSlice.actions,
};